/* =======david 31/12/25========= */
(function () {
  const drawer = document.querySelector('.catDrawer');
  if (!drawer) return;

  const openBtn = document.querySelector('[data-open-categories]');
  const closeBtn = drawer.querySelector('.catDrawer__close');
  const l1Buttons = drawer.querySelectorAll('.catL1__btn');
  const panels = drawer.querySelectorAll('.catPanel');

  // ✅ Desktop/tablet: >=768px
  const DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function activate(btn) {
    const id = btn.getAttribute('data-cat-target');
    l1Buttons.forEach(b => {
      const on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    panels.forEach(p => (p.hidden = (p.id !== id)));
  }

  function openDrawer() {
    if (!isDesktop()) return; // ✅ solo tablet+pc
    drawer.hidden = false;
    if (l1Buttons[0]) activate(l1Buttons[0]);
  }

  function closeDrawer() {
    drawer.hidden = true;
    l1Buttons.forEach(b => b.classList.remove('is-active'));
    l1Buttons.forEach(b => b.setAttribute('aria-expanded', 'false'));
    panels.forEach(p => (p.hidden = true));
  }

  // Hover SOLO en >=768, click siempre cambia panel (si el drawer está abierto)
  l1Buttons.forEach(btn => {
    btn.addEventListener('mouseenter', () => { if (isDesktop()) activate(btn); });
    btn.addEventListener('focus', () => { if (isDesktop()) activate(btn); });
    btn.addEventListener('click', () => { activate(btn); });
  });

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', (e) => { if (e.target === drawer) closeDrawer(); });
  document.addEventListener('keydown', (e) => { if (!drawer.hidden && e.key === 'Escape') closeDrawer(); });

  // Si pasas a móvil => cerramos drawer
  DESKTOP_MQ.addEventListener('change', () => {
    if (!isDesktop() && !drawer.hidden) closeDrawer();
  });

  // Seguridad: si carga en móvil, cerrado
  if (!isDesktop()) closeDrawer();
})();
